(() => {
  const categoryMatchers = {
    audio: /geluid|audio|speaker|subwoofer|microfoon|mixer|versterker/,
    lighting: /licht|moving|par|wash|beam|dmx|lamp/,
    stage: /podium|stage|stagedex|deck|poot|trap/,
    dj: /\bdj\b|cdj|djm|xdj|draaitafel/,
    video: /video|beeld|scherm|projector|beamer|hdmi|sdi/,
    rigging: /truss|rigging|takel|baseplate|coupler/,
    fx: /effect|confetti|rook|haze|sparkular|co2/,
    cable: /kabel|xlr|schuko|powercon|ethercon|haspel/,
  };

  const init = (root) => {
    if (!root || root.dataset.rslCoreSearchReady) return;
    const category = root.querySelector('[data-rsl-core-search-category]');
    const vehicle = root.querySelector('[data-rsl-core-search-vehicle]');
    const sort = root.querySelector('[data-rsl-core-search-sort]');
    const reset = root.querySelector('[data-rsl-core-search-reset]');
    const grid = document.querySelector('.rslr-search-page__grid');
    const empty = document.querySelector('[data-rsl-core-search-empty]');
    const count = document.querySelector('[data-rsl-core-search-count]');
    const initialCount = count?.textContent.trim();
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-rsl-core-search-item]'));

    const apply = () => {
      const categoryValue = category?.value || 'all';
      const vehicleValue = vehicle?.value || 'all';
      let visible = 0;
      cards.forEach((card) => {
        const categoryText = card.dataset.category || '';
        const vehicleText = card.dataset.vehicle || '';
        const categoryMatch = categoryValue === 'all' || categoryMatchers[categoryValue]?.test(categoryText);
        const vehicleMatch = vehicleValue === 'all'
          || (vehicleValue === 'car' && /auto|personenwagen|compact/.test(vehicleText))
          || (vehicleValue === 'van' && /bus|bestel|aanhang|vracht|groot/.test(vehicleText));
        card.hidden = !(categoryMatch && vehicleMatch);
        if (!card.hidden) visible += 1;
      });
      const mode = sort?.value || 'relevance';
      if (mode === 'relevance') {
        cards.forEach((card) => grid.appendChild(card));
      } else {
        const ordered = [...cards].sort((a, b) => {
          if (mode === 'name') return (a.dataset.name || '').localeCompare(b.dataset.name || '', 'nl');
          const first = Number(a.dataset.price || 0);
          const second = Number(b.dataset.price || 0);
          return mode === 'price-desc' ? second - first : first - second;
        });
        ordered.forEach((card) => grid.appendChild(card));
      }
      if (empty) empty.hidden = visible !== 0;
      if (count) count.textContent = categoryValue === 'all' && vehicleValue === 'all'
        ? initialCount
        : `${visible} van ${cards.length} artikelen op deze pagina passen bij je filters`;
    };

    root.addEventListener('change', apply);
    reset?.addEventListener('click', () => {
      if (category) category.value = 'all';
      if (vehicle) vehicle.value = 'all';
      if (sort) sort.value = 'relevance';
      cards.sort((a, b) => Number(a.dataset.originalIndex || 0) - Number(b.dataset.originalIndex || 0)).forEach((card) => grid.appendChild(card));
      apply();
    });
    cards.forEach((card, index) => { card.dataset.originalIndex = String(index); });
    root.dataset.rslCoreSearchReady = 'true';
    apply();
  };

  const initAll = () => document.querySelectorAll('[data-rsl-core-search-filters]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
})();
